import { splunk_message } from '../../common/splunk_constant';

// export const getUserAge = (dob: string) => {
export const getUserAge = (dob: string, splunkLogger?: (msg: any) => void) => {
 
  try {
    const today = new Date();
    const birthDateObj = new Date(dob);

    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
      age--;
    }

    return age;
  } catch (error:any) {
    if (splunkLogger) {
      splunkLogger({
        logType: 'error',
        data: { ...splunk_message?.ERROR?.USER_AGE_ERROR, error: error },
      });
    }
    return 0
  }
};
